module.exports = __webpack_public_path__ + "img/fabric.87abbcc6.png";